import { useEffect } from 'react';
import { RefreshCw, WifiOff, X } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from '@/components/feedback/toast';
import { Button } from '@/components/ui/button';

export function PwaUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Service Worker konnte nicht registriert werden.', error);
    }
  });

  useEffect(() => {
    if (!offlineReady) return;
    toast('Offline bereit', {
      description: 'DISCIPLINE kann jetzt ohne Internetverbindung geöffnet werden.',
      tone: 'info'
    });
    setOfflineReady(false);
  }, [offlineReady, setOfflineReady]);

  if (!needRefresh) return null;
  return (
    <div className="fixed inset-x-3 bottom-[calc(5.6rem+env(safe-area-inset-bottom))] z-[75] mx-auto flex max-w-lg items-center gap-3 rounded-2xl border border-accent/30 bg-surface p-4 shadow-lift lg:bottom-5">
      <div className="grid size-10 shrink-0 place-items-center rounded-xl bg-accent/10 text-accent">
        <WifiOff aria-hidden="true" className="size-4" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-ink">Update verfügbar</p>
        <p className="text-xs text-muted">Neu laden, sobald es für dich passt.</p>
      </div>
      <Button onClick={() => void updateServiceWorker(true)} size="sm">
        <RefreshCw aria-hidden="true" className="size-3.5" /> Aktualisieren
      </Button>
      <button
        aria-label="Update-Hinweis schließen"
        className="grid size-9 place-items-center rounded-lg text-muted hover:bg-elevated"
        onClick={() => setNeedRefresh(false)}
        type="button"
      >
        <X aria-hidden="true" className="size-4" />
      </button>
    </div>
  );
}
